import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

// Gate globale: qualunque pulsante "Registrati" pubblico può aprire la scelta
// tramite window.dispatchEvent(new Event("open-register-choice")).
const OPTS = [
  { role: "user", to: "/register/user" },
  { role: "professional", to: "/register/pro" },
  { role: "organization", to: "/register/org" },
];

export function RegisterChoiceGate() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const h = () => setOpen(true);
    window.addEventListener("open-register-choice", h);
    return () => window.removeEventListener("open-register-choice", h);
  }, []);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4" data-testid="register-choice-modal">
      <div className="absolute inset-0 bg-black/50" onClick={() => setOpen(false)} />
      <div className="relative bg-white w-full max-w-md rounded-2xl shadow-xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 flex items-center justify-between px-5 py-4 border-b border-slate-100 bg-white rounded-t-2xl">
          <h3 className="font-bold text-lg">{t("reg.title")}</h3>
          <button onClick={() => setOpen(false)} className="w-11 h-11 -mr-1 flex items-center justify-center rounded-full hover:bg-slate-100" aria-label="X" data-testid="register-choice-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-5 space-y-3">
          {OPTS.map((o) => (
            <div key={o.role} className="yp-card p-4" data-testid={`register-opt-${o.role}`}>
              <div className="font-semibold">{t(`reg.${o.role}_label`)}</div>
              <div className="text-sm text-slate-500 mt-1">{t(`reg.${o.role}_desc`)}</div>
              <Link to={o.to} onClick={() => setOpen(false)} className="yp-btn yp-btn-primary w-full mt-3 !py-2 text-sm" data-testid={`register-opt-${o.role}-btn`}>{t(`reg.${o.role}_btn`)}</Link>
            </div>))}
        </div>
      </div>
    </div>);
}
